﻿<script setup lang="ts">
    import { type Ref } from 'vue';
    import AiEditorKoWrapper from '@cwd/AiTools/AiEditorKoWrapper.vue';
    import AiSubject from '@cwd/AiTools/AiSubject.vue';
    import AiImagesModal from '@cwd/AiTools/AiImagesModal.vue';
    import koObsToRef from '@shared/utils/koObsToRef';
    import '@cwd/AiTools/aiTools.css';

    const props = defineProps<{
        tools: {
            createSurvey: {
                show: KnockoutObservable<boolean>;
                selectedSurveyId: KnockoutObservable<string>;
                surveyType: KnockoutObservable<string>;
            };
            editor: {
                contentEditable: any;
                sync: () => unknown;
                show: any;
            };
            subject: {
                show: KnockoutObservable<boolean>;
                get: () => string;
                update: (newVal: string) => void;
            };
            images: {
                show: any;
                clickImageAfterInsert: any;
                imageElement: any;
            };
            viewModel: any;
        };
    }>();

    const aiSubjectShow: Ref<boolean> = koObsToRef(props.tools.subject.show);

    const updateAiSubjectText = (newVal: string) => {
        props.tools.subject.update(newVal);
    };
</script>

<template>
    <AiEditorKoWrapper :editor="props.tools.editor"></AiEditorKoWrapper>
    <AiSubject :show="aiSubjectShow" @update:text="updateAiSubjectText" :getSubject="props.tools.subject.get" @close="aiSubjectShow = false"></AiSubject>
    <AiImagesModal :images="props.tools.images" :viewModel="props.tools.viewModel"></AiImagesModal>
</template>
